import { render, staticRenderFns } from "./UpdateFacilityCover.vue?vue&type=template&id=00a433dc&"
import script from "./UpdateFacilityCover.vue?vue&type=script&lang=js&"
export * from "./UpdateFacilityCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports